import { Box, Card, CardActions, CardContent, CardHeader, Container, Divider, Grid, Paper, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useCreateNotificationMutation } from "api/adminSlice";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import { cloneDeep, pick } from "lodash";
import runJoiValidate from "utils/runJoiValidate";
import { NOTIFICATIONS_SCHEMA } from "./ValidationSchemas";
import { Send } from "@mui/icons-material";
import { useTheme } from "@emotion/react";

export default function Notifications() {
    const theme = useTheme()
    const { t } = useTranslation()
    const [validationErrors, setValidationsErrors] = useState(null)
    const [createNotification,
        {
            isLoading: createNotificationLoading,
            isSuccess: createNotificationIsSuccess,
            error: createNotificationError,
            reset: createReset
        }
    ] = useCreateNotificationMutation()

    const [notification, setNotification] = useState({
        title_ar: '',
        body_ar: '',
        title_en: '',
        body_en: '',
    })

    const handleChange = ({ target: { value, name } }) => {
        setNotification(prevState => ({ ...prevState, [name]: value }))
    }

    const createNotificationHandler = async () => {
        createReset()
        setValidationsErrors(null)
        let payload = pick(cloneDeep(notification), ["title_en", "title_ar", "body_ar", "body_en"])
        const errors = runJoiValidate(NOTIFICATIONS_SCHEMA, payload)
        if (errors) {
            setValidationsErrors(errors)
            return
        }
        let response = await createNotification(payload).unwrap()
        if (response?.success) {
            setNotification({
                title_ar: '',
                body_ar: '',
                title_en: '',
                body_en: '',
            })
        }
    }

    return (
        <Container>
            <Card sx={{mt: 50}}>
                <CardHeader title={t('Send notification')} />
                <Divider />
                <CardContent>
                    <Grid container spacing={5} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <bdi>
                                <TextField
                                    fullWidth
                                    name="title_ar"
                                    placeholder="عنوان الإشعار بالعربى"
                                    value={notification?.title_ar ?? ""}
                                    onChange={handleChange}
                                    helperText={validationErrors?.title_ar ?? ''}
                                    error={!!validationErrors?.title_ar}
                                    label="عنوان الإشعار بالعربى" size="small" variant="outlined" margin="normal" />
                            </bdi>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <bdi>
                                <TextField
                                    fullWidth
                                    name="body_ar"
                                    placeholder="نص الإشعار بالعربى"
                                    value={notification?.body_ar ?? ""}
                                    onChange={handleChange}
                                    helperText={validationErrors?.body_ar ?? ''}
                                    error={!!validationErrors?.body_ar}
                                    label="نص الإشعار بالعربى" size="small" variant="outlined" margin="normal" />
                            </bdi>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <bdi>
                                <TextField
                                    fullWidth
                                    name="title_en"
                                    placeholder="The notification title in English"
                                    value={notification?.title_en ?? ""}
                                    onChange={handleChange}
                                    helperText={validationErrors?.title_en ?? ''}
                                    error={!!validationErrors?.title_en}
                                    label="The notification title in English" size="small" variant="outlined" margin="normal" />
                            </bdi>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <bdi>
                                <TextField
                                    fullWidth
                                    name="body_en"
                                    placeholder="The notification content in English"
                                    value={notification?.body_en ?? ""}
                                    onChange={handleChange}
                                    helperText={validationErrors?.body_en ?? ''}
                                    error={!!validationErrors?.body_en}
                                    label="The notification content in English" size="small" variant="outlined" margin="normal" />
                            </bdi>
                        </Grid>
                    </Grid>
                </CardContent>
                <Divider />
                <CardActions
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: 'row-reverse'
                    }}
                >
                    <LoadingButton
                        size="small"
                        variant="contained"
                        disableElevation
                        onClick={createNotificationHandler}
                        loading={createNotificationLoading}
                        startIcon={theme.direction === "rtl" && <Send />}
                        endIcon={theme.direction === "ltr" && <Send />}
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            mr: 5
                        }}
                    >
                        {t("Send notification")}
                    </LoadingButton>
                    <Box>
                        {createNotificationIsSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                        {createNotificationError && <Typography color="error">{t(createNotificationError)}</Typography>}
                    </Box>
                </CardActions>
            </Card>
        </Container>
    )
}